import { gql } from '@apollo/client';
import { MILESTONE_FIELDS, OUTCOME_FIELDS } from 'domain/shared/newProject';
export const GET_OUTCOMES_TAB_DATA = gql`
  query GetOutcomesTabData($id: ID!) {
    baseProject(id: $id) {
      id
      budget {
        id
        billingType
      }
      businessOutcomes {
        ${OUTCOME_FIELDS}
      }
      milestones {
        ${MILESTONE_FIELDS}
      }
    }
  }
`;
